const ADSENSE_CLIENT_ID = 'ca-pub-6029185588901953';
const ADSENSE_SCRIPT_ID = 'nova-google-adsense';
const PRODUCTION_HOSTNAMES = new Set(['novagame.io', 'www.novagame.io']);
const ROBOTS_META_NAME = 'robots';
const STAGING_ROBOTS_CONTENT = 'noindex, nofollow';

const getBrowserDocument = () => {
  if (typeof document === 'undefined') return null;
  return document;
};

const getBrowserHostname = () => {
  if (typeof window === 'undefined' || !window.location) return '';
  return window.location.hostname;
};

const normalizeHostname = (hostname = '') => hostname.trim().toLowerCase();

export const isProductionHostname = (hostname = '') => (
  PRODUCTION_HOSTNAMES.has(normalizeHostname(hostname))
);

export const isAdsenseAllowedByEnv = (env = import.meta.env) => (
  env?.VITE_ADSENSE_ENABLED !== 'false'
);

export const shouldLoadGoogleAdsense = ({
  env = import.meta.env,
  hostname = getBrowserHostname(),
} = {}) => (
  isProductionHostname(hostname) && isAdsenseAllowedByEnv(env)
);

export const applyRobotsPolicy = ({
  documentRef = getBrowserDocument(),
  hostname = getBrowserHostname(),
} = {}) => {
  if (!documentRef?.head) return 'skipped';

  const existingRobotsMeta = documentRef.querySelector(`meta[name="${ROBOTS_META_NAME}"]`);

  if (isProductionHostname(hostname)) {
    if (existingRobotsMeta?.dataset.novaManaged === 'true') {
      existingRobotsMeta.remove();
    }
    return 'indexable';
  }

  const robotsMeta = existingRobotsMeta || documentRef.createElement('meta');
  robotsMeta.setAttribute('name', ROBOTS_META_NAME);
  robotsMeta.setAttribute('content', STAGING_ROBOTS_CONTENT);
  robotsMeta.dataset.novaManaged = 'true';

  if (!existingRobotsMeta) {
    documentRef.head.appendChild(robotsMeta);
  }

  return 'noindex';
};

export const loadGoogleAdsense = ({
  clientId = ADSENSE_CLIENT_ID,
  documentRef = getBrowserDocument(),
  env = import.meta.env,
  hostname = getBrowserHostname(),
} = {}) => {
  if (!documentRef?.head || !shouldLoadGoogleAdsense({ env, hostname })) {
    return false;
  }

  if (documentRef.getElementById(ADSENSE_SCRIPT_ID)) {
    return true;
  }

  const script = documentRef.createElement('script');
  script.id = ADSENSE_SCRIPT_ID;
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(clientId)}`;
  script.crossOrigin = 'anonymous';

  documentRef.head.appendChild(script);
  return true;
};

export const initializeSearchAndAds = () => {
  applyRobotsPolicy();
  return loadGoogleAdsense();
};
